import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material"
import { useCallback, useState } from "react"
import { useUnbanV1TohMutation } from "../../core/api/toh-social-api"

const TohUnbanControl = ({ disabled, userId }) => {
    const [open, setOpen] = useState(false)
    const [reason, setReason] = useState("")

    const [unban, { isLoading }] = useUnbanV1TohMutation()

    const handleOpenDialog = useCallback(() => {
        setOpen(true)
    }, [setOpen])

    const handleCloseDialog = useCallback(() => {
        setOpen(false)
        setReason("")
    }, [setOpen, setReason])

    const handleChangeReason = useCallback((e) => {
        const value = e?.target?.value ?? ""
        if (value.length <= 50) {
            setReason(value)
        }
    }, [setReason])

    const handleConfirm = useCallback(() => {
        unban({
            userId: userId,
            reason: reason.trim()
        })
        handleCloseDialog()
    }, [userId, reason, unban, handleCloseDialog])

    return (
        <>
            <Button
                fullWidth
                color="error"
                loading={isLoading}
                size="small"
                disabled={disabled}
                variant={"outlined"}
                onClick={handleOpenDialog}
            >
                Unban on server
            </Button>
            <Dialog fullWidth maxWidth="sm" open={open} onClose={handleCloseDialog}>
                <DialogTitle>
                    Unban player '{userId}'
                </DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        fullWidth
                        multiline
                        rows={2}
                        margin="dense"
                        label="Reason"
                        value={reason}
                        onChange={handleChangeReason}
                        helperText={`${reason.length}/50`}
                        inputProps={{ maxLength: 50 }}
                    />
                </DialogContent>
                <DialogActions sx={{ justifyContent: "flex-end", alignItems: "center" }}>
                    <Button variant="contained" onClick={handleConfirm}>
                        Confirm
                    </Button>
                    <Button variant="outlined" onClick={handleCloseDialog}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default TohUnbanControl
